import bancoService from '@/service/GsFianza/banco'

export default {
    'BANCO_LIST': ({commit}) => {
        console.info(commit)
        return new Promise((resolve, reject) => {
            bancoService.findall().then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        });
    },
    'BANCO_SAVE': ({commit},params) => {
        console.info(commit)
        return new Promise((resolve, reject) => {
            bancoService.save(params).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        });
    },
    'BANCO_UPDATE': ({commit},params) => {
        console.info(commit)
        return new Promise((resolve, reject) => {
            bancoService.update(params).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        });
    },
    'BANCO_DELETE': ({commit},params) => {
        console.info(commit)
        return new Promise((resolve, reject) => {
            bancoService.delete(params).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        });
    }
}